define('lq/runtimeUrl',[
    'jquery',
    'underscore',
    'lq/queryString'
], function ($, _, queryString) {
    'use strict';

    var getLicquidParametersFromQueryString = function() {
        var parameters = {};

        _.each(queryString.getParameterNames(), function (parameterName) {
            if (parameterName.indexOf('lq_') === 0)
                parameters[parameterName] = queryString.getValueOf(parameterName);
        });

        return parameters;
    };

    var RuntimeUrl = function () {
        this.licquidParameters = getLicquidParametersFromQueryString();
    };

    RuntimeUrl.parameters = {
        language: 'lq_lang'
    };

    RuntimeUrl.prototype.overwriteLicquidParameter = function (parameter, value) {
        var self = this;
        _.each(_.keys(RuntimeUrl.parameters), function (paramName) {
            if (RuntimeUrl.parameters[paramName] === parameter)
                self.licquidParameters[parameter] = value;
        });
    };

    RuntimeUrl.prototype.prepare = function (url, queryStringObject) {
        queryStringObject = queryStringObject || {};

        var self = this;
        _.each(_.keys(this.licquidParameters), function (paramName) {
            queryStringObject[paramName] = self.licquidParameters[paramName];
        });

        return url + '?' + $.param(queryStringObject);
    };

    RuntimeUrl.prototype.openUrl = function (targetUrl, openBlank) {
        if (openBlank) {
            if (window.cordova && window.cordova.InAppBrowser) {
                window.cordova.InAppBrowser.open(targetUrl, "_system", "");
            } else {
                window.open(targetUrl, "_blank");
            }
        } else {
            window.location.href = targetUrl;
        }
    };
    
    return RuntimeUrl;
});
